import i18n from "core/i18n";
import { FrequencyNonLife } from "enums";

export const getLocalizedPensionStatementFrequencyMap = i18n.createGetLocalizedEnumMap(FrequencyNonLife);
